import React from 'react'
import DescriptionInput from 'ui-shared/WrappedInputs/DescriptionInput'
import CatalogItemBaseForm, {
  CatalogItemBaseFormProps,
} from './CatalogItemBaseForm'

export type ProductFormProps = CatalogItemBaseFormProps

const ProductForm: React.FC<CatalogItemBaseFormProps> = ({
  children,
  slotBeforeFacets,
  ...props
}) => {
  return (
    <CatalogItemBaseForm
      {...props}
      slotBeforeFacets={
        <>
          <DescriptionInput />
          {slotBeforeFacets}
        </>
      }
    >
      {children}
    </CatalogItemBaseForm>
  )
}

export default ProductForm
